export default async function postXml(url, file) {
    const endpoint = `${url}webcharts.com/child.xml`;

    const formData = new FormData();

    formData.append('file', file);

    const response = await fetch(endpoint, {
        method: 'POST',
        body: formData,
    }).then((res) => res.text());

    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(response, 'text/xml');
    return JSON.parse(xmlDoc.body.innerHTML);
}
